import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';

import R from 'common/res/R';

const styles = StyleSheet.create({
  tabContainer: {
    flexDirection: 'row',
    alignContent: 'stretch',
  },
  tab: {
    flex: 1,
    padding: R.spacing.xs,
  },
  tabText: {
    ...R.typography.weightMedium,
    opacity: 0.5,
    color: R.color.brand,
    textAlign: 'center',
    fontSize: R.typography.fontSize.tiny,
  },
  tabTextActive: {
    opacity: 1,
  },
});

class BusWagonTab extends React.Component {
  render() {
    const { tabs, activeTab, onClickTab } = this.props;

    return (
      <View style={styles.tabContainer}>
        {tabs.map((tabLabel, index) => (
          <View style={styles.tab} key={index}>
            <TouchableOpacity onPress={() => onClickTab(index)}>
              <Text
                style={[
                  styles.tabText,
                  index === activeTab && styles.tabTextActive,
                ]}
              >
                {tabLabel}
              </Text>
            </TouchableOpacity>
          </View>
        ))}
      </View>
    );
  }
}

export default BusWagonTab;
